import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NotifierService } from '../../services/notifier.service';
import { UserService } from '../../services/user.service';

// Duyệt nhiều cấp (Hrm.API HrApprovals) dùng chung cho hợp đồng (objectType 1) và lần tính lương (2).
// openFor(): xem các cấp, gửi duyệt (người gửi), duyệt / từ chối (người đến lượt), huỷ. openInbox(): việc chờ tôi duyệt.
// Quyền: hrApprovalsController 5 gửi (16), 6 duyệt (32), 7 huỷ (64).
export const APPROVAL_STATES = { 0: 'Chờ duyệt', 1: 'Đã duyệt', 2: 'Bị từ chối' };

@Component({
  selector: 'app-approval-panel',
  templateUrl: './approval-panel.component.html'
})
export class ApprovalPanelComponent {
  @Output() changed = new EventEmitter<any>();
  isShow = false;
  mode: 'detail' | 'inbox' = 'detail';
  objectType: number;
  objectKey: string;
  title = '';
  data: any = null;
  inbox: any[] = [];
  inboxType = 0;
  approvers: number[] = [];
  nextApprover: number = null;
  note = '';
  busy = false;
  userOptions: any[] = [];
  statusNames = { 0: 'Chờ duyệt', 1: 'Đã duyệt', 2: 'Từ chối', 9: 'Huỷ' };
  private uri = environment.apiDomain.hrmEndpoint + '/HrApprovals';

  constructor(private http: HttpClient, private notifier: NotifierService, private userService: UserService) { }

  get stateName(): string {
    return !this.data || this.data.state === null || this.data.state === undefined ? 'Chưa gửi duyệt' : APPROVAL_STATES[this.data.state];
  }
  get canSubmit(): boolean { return this.data && this.data.canSubmit && this.data.state !== 0; }

  async openFor(objectType: number, objectKey: string, title: string) {
    this.mode = 'detail';
    this.objectType = objectType; this.objectKey = objectKey; this.title = title;
    this.approvers = []; this.note = ''; this.nextApprover = null;
    this.isShow = true;
    await this.loadUsers();
    await this.load();
  }

  async openInbox(objectType: number = 0) {
    this.mode = 'inbox'; this.inboxType = objectType; this.title = 'Việc chờ tôi duyệt';
    this.isShow = true;
    await this.loadInbox();
  }

  async loadInbox() {
    const rs: any = await this.http.get(this.uri + '/MyPending').toPromise().catch(e => ({ status: false, message: e && e.message }));
    this.inbox = rs && rs.status ? (rs.data || []).filter(x => !this.inboxType || x.objectType === this.inboxType) : [];
  }

  async openItem(item: any) {
    await this.openFor(item.objectType, item.objectKey, item.title);
  }

  private async loadUsers() {
    if (this.userOptions.length) { return; }
    const rs: any = await this.userService.GetTdvByOrganization();
    this.userOptions = rs && rs.status ? (rs.data || []).map(u => ({ label: u.name, value: u.userId })) : [];
  }

  async load() {
    const rs: any = await this.http.get(`${this.uri}/Steps?objectType=${this.objectType}&objectKey=${encodeURIComponent(this.objectKey)}`).toPromise()
      .catch(e => ({ status: false, message: e && e.message }));
    if (!rs || !rs.status) { this.notifier.showError(rs && rs.message || 'Không tải được thông tin duyệt.'); this.data = null; return; }
    this.data = rs.data;
  }

  userName(id: number) {
    const u = this.userOptions.find(x => x.value === id);
    return u ? u.label : '#' + id;
  }

  addApprover() {
    if (!this.nextApprover || this.approvers.indexOf(this.nextApprover) >= 0) { return; }
    this.approvers.push(this.nextApprover);
    this.nextApprover = null;
  }

  removeApprover(i: number) { this.approvers.splice(i, 1); }

  moveUp(i: number) {
    if (i <= 0) { return; }
    const t = this.approvers[i - 1]; this.approvers[i - 1] = this.approvers[i]; this.approvers[i] = t;
  }

  private async post(path: string, body: any) {
    this.busy = true;
    try {
      const rs: any = await this.http.post(this.uri + path, body).toPromise();
      if (rs && rs.status) {
        this.notifier.showSuccess(rs.message);
        this.note = ''; this.approvers = [];
        await this.load();
        this.changed.emit({ objectType: this.objectType, objectKey: this.objectKey, state: this.data && this.data.state });
      } else {
        this.notifier.showError(rs && rs.message || 'Không thực hiện được.');
      }
    } catch (e) {
      this.notifier.showError(e && e.message || 'Không thực hiện được.');
    } finally {
      this.busy = false;
    }
  }

  submit() {
    if (!this.approvers.length) { this.notifier.showWarning('Thêm ít nhất một người duyệt.'); return; }
    return this.post('/Submit', { objectType: this.objectType, objectKey: this.objectKey, approverUserIds: this.approvers, note: this.note });
  }

  act(approve: boolean) {
    if (!approve && !this.note.trim()) { this.notifier.showWarning('Nhập lý do từ chối.'); return; }
    return this.post('/Act', { objectType: this.objectType, objectKey: this.objectKey, approve, note: this.note });
  }

  cancel() {
    return this.post(`/Cancel?objectType=${this.objectType}&objectKey=${encodeURIComponent(this.objectKey)}`, {});
  }
}
